import classes from './homeScreen.module.scss';
import { useNavigate } from 'react-router-dom';
import factsIcon from 'assets/icons/facts.svg';
import fdpIcon from 'assets/icons/fdp.svg';
import bdPortalIcon from 'assets/icons/BD.svg';
import { useStore } from 'hooks/useStore';
import { useState } from 'react';
import { authServices } from 'services/authServices';
import { Button } from 'primereact/button';
import Navbar from 'components/navbar';
import { observer } from 'mobx-react';
import { homePageAnimationStringHTML } from './utils/homePageAnimationCreator';

const HomeScreen = () => {
  const navigate = useNavigate();
  const {
    UserStore: { isAuthenticated },
    FeatureFlagStore,
  } = useStore();
  const [isLoginRedirectLinkLoading, setIsLoginRedirectLinkLoading] = useState(false);

  const flagEnabled = (key: string) => !FeatureFlagStore.isLoaded || FeatureFlagStore.isEnabled(key);

  const showFacts =
    flagEnabled('facts.active_drug_strategy') || flagEnabled('facts.drug_portfolio');
  const showFDP =
    flagEnabled('fdp.tms') ||
    flagEnabled('fdp.unconstrained_forecast') ||
    flagEnabled('fdp.constrained_forecast') ||
    flagEnabled('fdp.supplier_forecast') ||
    flagEnabled('fdp.provisional_forecast');
  const showBDPortal =
    flagEnabled('bdportal.opportunity_tracker') ||
    flagEnabled('bdportal.product_wiki') ||
    flagEnabled('bdportal.bid_analysis');

  const login = async () => {
    try {
      setIsLoginRedirectLinkLoading(true);
      const res = await authServices.initiateLogin();
      window.location.href = res.loginRedirectUrl;
    } catch {
      setIsLoginRedirectLinkLoading(false);
      console.log('Error occured while logging in');
    } finally {
      // intentionally empty
    }
  };

  return (
    <div className={classes.fdpScreenContainer}>
      {isAuthenticated ? (
        <div>
          <div className={classes.fdpScreenContainersub}>
            <div className={classes.navbar}>
              <Navbar heading={'Product Life Cycle Management'} />
            </div>
            {showFacts && (
              <div className={classes.btnSection} onClick={() => navigate('/facts')}>
                <div>
                  <div className={classes.imgBackground}>
                    <img src={factsIcon} alt="facts icon" />
                  </div>
                </div>
                <p>Facts</p>
              </div>
            )}

            {showFDP && (
              <div className={classes.btnSection} onClick={() => navigate('/fdp')}>
                <div>
                  <div className={classes.imgBackground}>
                    <img src={fdpIcon} alt="fdp icon" />
                  </div>
                </div>
                <p>FDP</p>
              </div>
            )}

            {showBDPortal && (
              <div className={classes.btnSection} onClick={() => navigate('/bdportal')}>
                <div>
                  <div className={classes.imgBackground}>
                    <img src={bdPortalIcon} alt="bd portal icon" />
                  </div>
                </div>
                <p>BD Portal</p>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div>
          <div className={classes.homeScreenMenuLoginSection}>
            <div className={classes.textSection}>
              <div className={classes.title}>Product Life Cycle Management</div>
            </div>
            <Button
              style={{
                backgroundColor: 'white',
                color: 'black',
                fontWeight: 600,
                border: 'none',
                borderRadius: '20px',
                width: '15rem',
                textAlign: 'center',
              }}
              onClick={login}
              loading={isLoginRedirectLinkLoading}
            >
              <span style={{ marginLeft: '0.5rem' }}>Click Here to Login</span>
              {!isLoginRedirectLinkLoading && (
                <img style={{ marginLeft: '1rem' }} src="homePage/images/arrow.svg" />
              )}
            </Button>
          </div>

          <iframe
            className={classes.homeScreenLoginAnimatedPage}
            srcDoc={homePageAnimationStringHTML()}
            style={{
              width: '100%',
              height: '100vh',
              border: 'none',
              overflow: 'hidden', // Prevent scrolling in the iframe itself
            }}
            title="GSMS Landing Page"
            scrolling="no" // Older method to disable scrollbars
          />
        </div>
      )}
    </div>
  );
};

export default observer(HomeScreen);
